import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Menu, Transition } from '@headlessui/react'
import { Fragment, useState } from 'react'
import useRedux from 'redux/useRedux'

const DropdownItem = ({
    item,
    depth = 0,
    onClickItems,
    lang,
    activeMenuSidebar
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const hasSubMenu = item?.sub_menu?.length > 0;
    const isActive = activeMenuSidebar?.path === item?.path;

    if (item?.title === "Laporan Penilaian GCG") {
        return null;
    }

    if (hasSubMenu) {
        return (
            <div className={`${depth > 0 ? 'pl-4' : ''}`}>
                <button
                    className={`text-left flex w-full items-center justify-between rounded-md p-4 text-sm ${isActive ? 'text-active' : 'text-gray-900'}`}
                    onClick={() => setIsOpen((prev) => !prev)}
                    type="button"
                >
                    <span>{lang === "en" ? (item?.title_en ? item?.title_en : item?.title) : item?.title}</span>
                    <FontAwesomeIcon icon={faChevronDown} color={isActive ? '#2FB6E9' : '#333333'} className={`${isOpen ? 'rotate-180' : ''} transition-transform`} />
                </button>
                {isOpen && item?.sub_menu?.map((submenu, index) => (
                    <DropdownItem
                        key={`${submenu?.path || submenu?.title}-${index}`}
                        item={submenu}
                        depth={depth + 1}
                        onClickItems={onClickItems}
                        lang={lang}
                        activeMenuSidebar={activeMenuSidebar}
                    />
                ))}
            </div>
        );
    }

    return (
        <button
            className={`${isActive ? 'text-active' : 'text-gray-900'} text-left flex w-full items-center rounded-md p-4 text-sm ${depth > 0 ? 'pl-8' : ''}`}
            onClick={() => onClickItems(item)}
            type="button"
        >
            {lang === "en" ? (item?.title_en ? item?.title_en : item?.title) : item?.title}
        </button>
    );
};

const BasicDropdown = ({
    title,
    items = [],
    onClickItems,
    classNameItems,
    colorChevron,
    active
}) => {
    const lang = localStorage.getItem('i18nextLng');

    const {
        global: {
            activeMenuSidebar
        }
    } = useRedux();

    return (
        <div className="">
            <Menu as="div" className="relative inline-block text-left">
                <div>
                    <Menu.Button className="inline-flex w-full justify-center rounded-md">
                        {title && (
                            <div className='flex flex-row'>
                                <div className={`mr-2 ${active ? 'text-active' : ''}`}>{title}</div>
                                {
                                    items.length > 0 && <div><FontAwesomeIcon icon={faChevronDown} color={active ? '#2FB6E9' : colorChevron} /></div>
                                }
                            </div>
                        )}
                    </Menu.Button>
                </div>
                {
                    items.length > 0 &&
                    <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                    >

                        <Menu.Items className={`
                        absolute right-0 mt-2 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg 
                        ring-1 ring-black ring-opacity-5 focus:outline-none z-10
                        ${classNameItems}`}>
                            {
                                items?.map((val, ind) => (
                                    <DropdownItem
                                        key={`${val?.path || val?.title}-${ind}`}
                                        item={val}
                                        onClickItems={onClickItems}
                                        lang={lang}
                                        activeMenuSidebar={activeMenuSidebar}
                                    />
                                ))
                            }
                        </Menu.Items>

                    </Transition>
                }
            </Menu>
        </div>
    )
}

export default BasicDropdown
